import { Box, Skeleton } from '@mui/material'

const SegmentBaggageLoader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                gap: 1,
                fontSize: 12,
                color: 'textColors.secondary',
                alignItems: 'flex-start',
                mt: { xs: 2, lg: 0.5 }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width={80} height={14} />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width={60} height={14} />
            </Box>
        </Box>
    )
}

export default SegmentBaggageLoader
